import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

export var ViewportUtils =
/*#__PURE__*/
function () {
  function ViewportUtils() {
    _classCallCheck(this, ViewportUtils);
  }

  _createClass(ViewportUtils, null, [{
    key: "getMobileFirstValue",
    // finds the value matching the mobile-first notation, definitions like {xs: 5, md: 20} will return 5 in viewport sm
    value: function getMobileFirstValue(definitions, viewport) {
      var _this = this;

      var viewports = ["xs", "sm", "md", "lg", "xl"];
      var mobileFirstViewport = viewports.reduce(function (acc, v) {
        _newArrowCheck(this, _this);

        if (definitions[v]) {
          acc.bestViewport = v;
        }

        if (viewport === v) {
          acc.finalViewport = acc.bestViewport;
        }

        return acc;
      }.bind(this), {
        bestViewport: "",
        finalViewport: ""
      });
      return definitions[mobileFirstViewport.finalViewport];
    }
  }]);

  return ViewportUtils;
}();